import { render, staticRenderFns } from "./ColorSelected.vue?vue&type=template&id=eb3ca71e&"
import script from "./ColorSelected.vue?vue&type=script&lang=js&"
export * from "./ColorSelected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports